import React, { useContext } from "react";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

const TAB_DATOS = "Datos del móvil";
const TAB_LIQ = "Liquidaciones";

const columns = [
  { field: "id", header: "ID", width: "6rem" },
  { field: "nombre", header: "Nombre" },
  { field: "detalle", header: "Detalle" },
  { field: "matricula", header: "Matrícula" },
  { field: "marca", header: "Marca" },
  { field: "modelo", header: "Modelo" },
  { field: "seguro", header: "Seguro" },
  { field: "tipoMovil", header: "Tipo de móvil" },
  { field: "habilitado", header: "Habilitado", type: "bool", width: "9rem" },
];

const proximoId = (arr) => {
  for (let id = 1; id < 1000; id++) {
    if (!arr.some((m) => m.id === id)) return id;
  }
  return 1;
};

export default function MovilesPropios() {
  const {
    moviles,
    tiposMoviles,
    obtenerMoviles,
    obtenerTiposMoviles,
    agregarMovil,
    actualizarMovil,
  } = useContext(ConfiguracionContext);

  const fields = [
    {
      name: "id",
      label: "ID",
      type: "number",
      tab: TAB_DATOS,
      md: 2,
      disabled: (editando) => editando,
      onChange: (v) => ({
        id: v,
        nombre: "MOVIL " + String(v).padStart(3, "0"),
      }),
      validar: (v) => {
        if (v === "" || v == null) return "El ID de móvil es necesario !.";
        const n = Number(v);
        return n > 0 && n <= 999
          ? null
          : "El ID de móvil es incorrecto (1 - 999) !.";
      },
    },
    { name: "nombre", label: "Nombre", type: "text", tab: TAB_DATOS, md: 10, disabled: true },
    { name: "detalle", label: "Detalle", type: "text", tab: TAB_DATOS, md: 12 },
    { name: "matricula", label: "Matrícula", type: "text", tab: TAB_DATOS, md: 4 },
    { name: "marca", label: "Marca", type: "text", tab: TAB_DATOS, md: 4 },
    { name: "modelo", label: "Modelo", type: "text", tab: TAB_DATOS, md: 4 },
    { name: "seguro", label: "Seguro", type: "text", tab: TAB_DATOS, md: 3 },
    { name: "poliza", label: "Póliza", type: "text", tab: TAB_DATOS, md: 3 },
    {
      name: "tipoId",
      label: "Tipo de móvil",
      type: "select",
      tab: TAB_DATOS,
      md: 6,
      required: true,
      requiredMsg: "El tipo de móvil es necesario !.",
      options: tiposMoviles || [],
      optionLabel: "nombre",
      optionValue: "id",
    },
    { name: "habilitado", label: "Habilitado", type: "switch", tab: TAB_DATOS, md: 12 },

    { name: "valorHora", label: "Valor Hora", type: "number", tab: TAB_LIQ, md: 3 },
    { name: "valorNocturno", label: "Valor Nocturno", type: "number", tab: TAB_LIQ, md: 3 },
    { name: "valorSadofe", label: "Valor Sa-Do-Fe", type: "number", tab: TAB_LIQ, md: 3 },
  ];

  return (
    <MaestroArchivo
      titulo="Móviles Propios"
      entidad="móvil"
      layout="Moviles"
      icono={<LocalShippingOutlinedIcon />}
      items={moviles}
      listo={Boolean(tiposMoviles)}
      columns={columns}
      fields={fields}
      anchoDialog="md"
      nuevoDefault={(items) => {
        const id = proximoId(items);
        return {
          id,
          nombre: "MOVIL " + String(id).padStart(3, "0"),
          propio: true,
          detalle: "",
          matricula: "",
          marca: "",
          modelo: "",
          seguro: "",
          poliza: "",
          telefono: null,
          contacto: null,
          habilitado: true,
          nocturnoDesde: null,
          nocturnoHasta: null,
          pediatrico: null,
          tripulacionId: null,
          tipoId: null,
          valorHora: 0,
          valorNocturno: 0,
          valorSadofe: 0,
        };
      }}
      onMount={() => obtenerTiposMoviles()}
      onObtener={() => obtenerMoviles({ todos: true, propios: true })}
      onAgregar={(data) => agregarMovil({ movil: data })}
      onActualizar={(data) => actualizarMovil({ movil: data })}
    />
  );
}
